import citiesList from "./cities.json"

export const validateSwissPostCode = (value) => {
  const numValue = +value
  const foundValid = citiesList.find((city) => city["Zip code"] === numValue)
  return !!foundValid
}
